export default class Resource {
  static msg(key, file) {
    let label = key;

    try {
      label = window.Resources[file][key];
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(`Could not retrieve property label for ${key}`);
    }

    return label;
  }
}
